// Libraries
import { useMemo } from "react";
import { Grid } from "@mui/material";

// Layouts
import CustomerNameSection from "./CustomerNameSection";
import CustomerCommConsentSection from "./CustomerCommConsentSection";

// Contexts
import { useLeadsContext } from "@/DataPages/context/crm/LeadsContext";

// Components
import SectionDivider from "../../SectionDivider";
import CustomerContactSection from "./CustomerContactSection";
import CustomerTypeRadioGroup from "./CustomerTypeRadioGroup";

// Helpers
import CustomerAddressSection from "./CustomerAddressSection";
import { isIndividual } from "../../../helpers";

// Types
import { TCustomerType } from "@/DataPages/context/crm/interfaces";

export function CustomerInformationTab() {
	/* Context */
	const { getContextValue } = useLeadsContext();

	/* useMemo */
	const { customerType, firstInputLabel, secondInputLabel, thirdInputLabel } = useMemo(() => {
		const customerType = getContextValue<TCustomerType>("customer", "type");
		const isIndividualValue = isIndividual(customerType);
		const firstInputLabel = isIndividualValue ? "First Name" : "Business Name";
		const secondInputLabel = isIndividualValue ? "Middle Name" : "Business Contact First Name";
		const thirdInputLabel = isIndividualValue ? "Last Name" : "Business Contact Last Name";

		return { customerType, isIndividualValue, firstInputLabel, secondInputLabel, thirdInputLabel };
	}, [getContextValue<TCustomerType>("customer", "type")]);

	return (
		<Grid className="!w-full">
			<CustomerTypeRadioGroup />
			<CustomerNameSection firstInputLabel={firstInputLabel} secondInputLabel={secondInputLabel} thirdInputLabel={thirdInputLabel} />
			<SectionDivider />
			<CustomerAddressSection customerType={customerType} />
			<SectionDivider />
			<CustomerContactSection />
			<SectionDivider />
			<CustomerCommConsentSection />
		</Grid>
	);
}

export default CustomerInformationTab;
